import React, { useEffect, useState } from "react";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import ClipLoader from "react-spinners/ClipLoader";
import useAuthAxios from "../../../utils/baseAxios";
import { API } from "../../../constants/api";
import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";
import { errorMessage } from "../../../utils/errorMessage";
import { validateChangePassword } from "../../../utils/validations";
import OtpPin from "../../../components/OtpPin";

const ChangePassword = ({ setOpenPassword }: any) => {
  const [newPassword, setNewPassword] = useState<string>("");
  const [otpScreen, setOtpScreen] = useState<boolean>(false);

  const [viewConfirmedPassword, setViewConfirmedPassword] =
    useState<boolean>(false);
  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(59);
  const [sendOtp, setSendOtp] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [otp, setOtp] = useState<string>("");

  const axiosInstance = useAuthAxios();
  useEffect(() => {
    if (!newPassword) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [newPassword]);
  useEffect(() => {
    if (seconds > 0 || minutes > 0) {
      setSendOtp(true);
    } else {
      setSendOtp(false);
    }
  }, [seconds, minutes]);

  const resendOtp = () => {
    axiosInstance
      .post(API.requestOTP, {
        purpose: "change-password",
      })
      .then((r: any) => {})
      .catch((e: any) => {
        console.log(e.response.data.message);
      });

    setMinutes(0);
    setSeconds(59);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const sendPasswordotp = async ({ purpose }: any) => {
    const response = await axiosInstance.post(API.requestOTP, {
      purpose,
    });
    return response.data;
  };
  const completeSendOTP = useMutation({
    mutationFn: sendPasswordotp,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setOtpScreen(true);
      }, 1500);
    },
    onError: (e) => {
      console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  const updatePassword = async ({ newPassword, otp }: any) => {
    const response = await axiosInstance.patch(API.changePassword, {
      newPassword,
      otp,
    });
    return response.data;
  };
  const completeUpdatePassword = useMutation({
    mutationFn: updatePassword,
    onSuccess: (r) => {
      toast.success(r.message);

      setTimeout(() => {
        setOpenPassword(false);
      }, 2000);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              if (otpScreen) {
                setOtpScreen(false);
              } else {
                setOpenPassword(false);
              }
            }}
          >
            <BsArrowLeft className="text-black dark:text-gray-200 text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Change password
          </h4>
        </div>
        {otpScreen ? (
          <div className="mt-10 w-full">
            <h4 className="font-manrope w-full mb-6 dark:text-gray-200 text-gray-800 text-center font-medium text-[14px] ">
              Enter the 6-digit verification code sent to your email to verify
              this action.
              <br />
              Not receiving OTP? Chack spam folder.
            </h4>
            <OtpPin otp={otp} setOtp={setOtp} input={6} />
            <button
              onClick={() => {
                completeUpdatePassword.mutate({
                  newPassword: newPassword,
                  otp: otp,
                });
              }}
              disabled={otp.length !== 6 || completeUpdatePassword.isPending}
              className={
                otp.length !== 6
                  ? "w-full bg-gray-400 rounded-xl flex justify-center items-center text-gray-100 text-[15px] font-medium mt-12 h-[48px]"
                  : "w-full bg-secondary_button rounded-xl flex justify-center items-center text-white text-[15px] font-medium mt-12 h-[48px]"
              }
            >
              {completeUpdatePassword.isPending ? (
                <ClipLoader color="#ffffff" size={20} />
              ) : (
                "Change Password"
              )}
            </button>
          </div>
        ) : (
          <div className="w-full mt-8">
            <h4 className="text-gray-800 dark:text-gray-200 text-[15px] font-medium">
              Enter your new password details
            </h4>
            <form
              className="w-full "
              onSubmit={(e) => {
                e.preventDefault();
                if (!validateChangePassword(newPassword)) {
                  return;
                }
                completeSendOTP.mutate({
                  purpose: "change-password",
                });
              }}
            >
              <label className="relative  flex items-center ">
                <input
                  type={viewConfirmedPassword ? "text" : "password"}
                  value={newPassword}
                  placeholder="New Password"
                  onChange={(e) => setNewPassword(e.target.value)}
                  name="New password"
                  className="h-[50px] dark:bg-[#1F2B36] dark:text-gray-200 dark:border-[#095B97] w-full mt-4 px-[16px] font-manrope border-2 border-opacity-60 rounded-lg border-[#4A4A68] outline-none text-[#4A4A68] transition duration-200"
                />
                {/* <span className="text-base mt-8 text-[#4A4A68] text-opacity-0 left-2 pt-4  px-[2px] transition duration-200 input-text absolute">
                New Password
              </span> */}
                {!viewConfirmedPassword ? (
                  <AiOutlineEyeInvisible
                    className="text-3xl -ml-10 mt-[20px] text-[#4A4A68] dark:text-gray-200"
                    onClick={() => setViewConfirmedPassword((prev) => !prev)}
                  />
                ) : (
                  <AiOutlineEye
                    className="text-3xl -ml-10 mt-[20px] text-[#4A4A68] dark:text-gray-200"
                    onClick={() => setViewConfirmedPassword((prev) => !prev)}
                  />
                )}
              </label>

              <button
                type="submit"
                disabled={disabled || completeSendOTP.isPending}
                className={
                  disabled
                    ? "w-full h-[52px] flex justify-center  items-center font-manrope mx-auto  font-medium rounded-xl text-gray-200 bg-gray-400 mt-8 lgss:mt-8"
                    : "w-full h-[52px] flex justify-center items-center font-manrope mx-auto  font-medium rounded-xl text-white bg-secondary_button mt-8 lgss:mt-8"
                }
              >
                {completeSendOTP.isPending ? (
                  <ClipLoader color="#FFFFFF" size={30} />
                ) : (
                  "Change password"
                )}
              </button>
              <div className="flex justify-center mt-4 items-center">
                {seconds > 0 || minutes > 0 ? (
                  <p className="text-paragraph dark:text-gray-200  font-bold text-[12px]">
                    Time Remaining:{" "}
                    <span className="text-secondary_button">
                      {minutes < 10 ? `0${minutes}` : minutes}:{" "}
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </span>
                  </p>
                ) : (
                  <p className="font-bold  text-paragraph dark:text-gray-200 text-[12px]">
                    Didn't recieve code?
                  </p>
                )}
                {!sendOtp && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      resendOtp();
                    }}
                    className="text-secondary_button text-[12px] flex justify-center items-center ml-2 font-bold"
                  >
                    Resend OTP
                  </button>
                )}
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangePassword;
